import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import "./contact.css";
import * as Yup from "yup";
import CustomInput from "../../../components/CustomInput/CustomInput";
import api from "../../../api/api";
import getToken from "../../getToken";
import apiUtil from "../../../api/apiUtil";

const Contact = () => {
  const [contactDetail, setContactDetail] = useState({
    phoneNumber: "",
    email: "",
    address: "",
  });

  const getContactDetail = () => {
    api
      .get("Admin/GetSettingDetailByAdmin", { Name: "ContactInfo" }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data.data);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setContactDetail(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
  };

  const EditContactFormValidation = Yup.object().shape({
    phoneNumber: Yup.string()
      // .test(
      //   "phoneNumber",
      //   "Please enter format phone number.",
      //   (val) => /^\+?(95)?\d{9,12}$/.test(val)
      // )
      .required("Please enter the phone number"),
    email: Yup.string()
    .test("email", "Please enter the correct email address.", (val) =>
      apiUtil.emailValidation(val)
    )
        .required("Please enter the email"),
    //   ),
    address: Yup.string().required("Please enter the address."),
  });

  let brandId = localStorage.getItem("brandId");
  const handleSubmitContactForm = (values, actions) => {
    debugger;
    const contact = {
      id: "03a0c54e-7131-4f04-c5bd-08db447f5086",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "ContactInfo",
      valueInText: values.phoneNumber + " & " + values.email,
      valueInInt: "0",
      valueInJson: values.address,
    };

    api
      .post("Admin/UpdateSettingByAdmin", contact, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Contact updated successfully!!");
              getContactDetail();
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
    actions.setSubmitting(false);
  };

  const extractValue = (text, index) => {
    if (!text) return "";
    const splitValues = text.split(" & ");
    return splitValues[index] ? splitValues[index].trim() : "";
  };

  useEffect(() => {
    getContactDetail();
  }, []);

  return (
    <div className="contact-us">
      <h4 className="title_text mt-2 ps-3">Edit Contact Us</h4>

      <Formik
        initialValues={{
          phoneNumber: extractValue(contactDetail.valueInText, 0),
          email: extractValue(contactDetail.valueInText, 1),
          address: contactDetail.valueInJson ? contactDetail.valueInJson : "",
        }}
        validateOnBlur={false}
        enableReinitialize={true}
        validationSchema={EditContactFormValidation}
        onSubmit={(values, actions) => {
          handleSubmitContactForm(values, actions);
        }}
      >
        <Form className="row form-container contact-form">
          <h4 className="title_text mt-2 info-title">Contact Information</h4>
          <div className="col-12">
            <CustomInput
              name="phoneNumber"
              label="Phone Number"
              type="text"
              customclass="input_wrapper"
              hideicon="true"
            />
          </div>
          <div className="col-12">
            <CustomInput
              name="email"
              label="Email"
              type="text"
              customclass="input_wrapper"
              hideicon="true"
            />
          </div>
          <div className="col-12 mt-2">
            <CustomInput
              name="address"
              label="Address"
              type="text"
              customclass="input_wrapper"
              hideicon="true"
            />
          </div>
          <div className="col-12 mt-3">
            <div className="Actions justify-content-end">
              <button type="button" className="button btnCancel">
                Cancel
              </button>
              <button type="submit" className="button btnUpdate">
                Save
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default Contact;
